import {Injectable} from "@angular/core";
import {DataService} from "./data.service";
import {ApiEndpoints} from "./ApiEndpoints";
import {UserModel} from "../model/user.model";
import {map} from "rxjs/operators";
import {Observable, of} from "rxjs";

@Injectable()
export class UserService extends DataService{

  currentUser: UserModel = null;

  getUsers() {
    return this.getRequest(ApiEndpoints.users);
  }

  getUserByID(id) {
    return this.getRequest(`${ApiEndpoints.users}/${id}`);
  }

  getUser() {
    if (this.currentUser) {
      return this.currentUser
    }
    return this.getRequest(ApiEndpoints.me)
      .pipe(map((response:any) => {
        this.currentUser = new UserModel(response);
        return this.currentUser;
      }));
  }

  getUserPromise(): Observable<any> {
    if (this.currentUser) {
      return of(this.currentUser);
    }
    return this.getRequest(ApiEndpoints.me)
  }

  saveUser(userID, companies, role) {
    return this.postRequest(ApiEndpoints.user_company, {id: userID, companies: companies, role: role})
  }
}
